import { User } from 'firebase/auth'
import * as Sentry from '@sentry/browser'
import { BrandEnum } from '@/firebase/auth/auth-jwt-schema'
import { isPaxtonBrand } from '@/util/enterprise'

// Sentry-only user tagging. Does not register the user with any analytics pipeline.
export function setSentryUser(user: User | null, brand: BrandEnum = BrandEnum.NONE) {
  if (user == null) return

  const userProperties = {
    id: user.uid,
    ...(user.email && { email: user.email }),
    brand: brand,
  }

  if (userProperties['email'] && !isPaxtonBrand(brand)) {
    delete userProperties['email']
  }

  Sentry.setUser(userProperties)
}
